import React from "react";

/**
 * Grid of selectable time-slot buttons.
 * - `availability[slot] === false` marks a slot as full.
 * - `capacityInfo[slot].available_spots` (when known) must cover `teamSize`, and is shown as "free/max".
 * - `currentSlot` is highlighted and not selectable (used when moving an existing reservation).
 */
const SlotGrid = ({
  slots,
  availability = {},
  capacityInfo = {},
  value = null,
  onChange,
  teamSize = 1,
  currentSlot = null,
  wide = false,
}) => (
  <div className={`slots ${wide ? "wide" : ""}`.trim()} role="group" aria-label="Časové sloty">
    {slots.map((slot) => {
      const capacity = capacityInfo[slot];
      const freeSpots = capacity?.available_spots;
      const isCurrent = slot === currentSlot;
      const isFull = !isCurrent && (availability[slot] === false || (freeSpots !== undefined && freeSpots < teamSize));
      const className = ["slot", isCurrent ? "current" : "", isFull ? "full" : ""].join(" ").trim();
      const title = isFull ? "Obsazeno" : capacity ? `Volná místa: ${freeSpots}/${capacity.max_capacity}` : undefined;

      return (
        <button
          key={slot}
          type="button"
          className={className}
          aria-pressed={value === slot}
          aria-current={isCurrent ? "true" : undefined}
          aria-disabled={isCurrent || undefined}
          disabled={isFull}
          title={title}
          onClick={() => {
            if (!isCurrent) onChange(slot);
          }}
        >
          {slot}
          {isCurrent && <span className="sr"> (aktuální čas)</span>}
          {capacity && (
            <span className="cap">
              {freeSpots}/{capacity.max_capacity}
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default SlotGrid;
